import React from 'react';
import { Button, Form, Grid, Input, Segment, TextArea } from 'semantic-ui-react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class AddDisciplinaryMeasures extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            documentNumber: null,
            comment: '',
            startDateErr: false,
            endDateErr: false,


        };
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        if (this.props.edit) {
            let disciplinaryMeasuresObject = JSON.parse(localStorage.getItem('disciplinaryMeasuresObject'));
            let measure = disciplinaryMeasuresObject.disciplinaryMeasure.id;
            let {
                startDate, endDate, documentNumber, comment, optLock, id
            } = disciplinaryMeasuresObject;
            this.setState({
                startDate: new Date(startDate), endDate: new Date(endDate), documentNumber, comment, dmId: id, optLock, measure
            });
        }

        axios.get('/disciplinary-measures')
            .then(res => {
                const measures = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ measures });
            })
            .catch(err => {
                console.log('Failed to fetch measures.');
            });
    }
    addMeasures(measure) {
        if (!measure || !this.state.startDate || !this.state.endDate) {
            toast('Niste unijeli sva obavezna polja!');
            this.setState({ measureErr: true, startDateErr: true, endDateErr: true });
        } else {
            let obj = {

                studentStudyProgram: { id: this.props.studentStudyProgramId },
                disciplinaryMeasure: { id: this.state.measure },
                documentNumber: this.state.documentNumber,
                startDate: moment(this.state.startDate).format(),
                endDate: moment(this.state.endDate).format(),
                comment: this.state.comment,

            };
            axios.post('disciplinary-procedure/add/', { ...obj })
                .then(res => {
                })
                .then(ress => {
                    this.props.updateStatus();
                    this.props.toggleDisciplinaryVisibility();
                    toast('Dodavanje disciplinske mjere je uspješno izvršeno.');
                    this.setState({ measureErr: false, startDateErr: false, endDateErr: false });
                })
                .then(res => {
                    this.props.closeForm();
                })
                .catch(err => {
                    console.log('Failed to add measure');
                    toast('Došlo je do greške! Dodavanje disciplinske mjere nije uspješno izvršeno.');
                });
        }
    }
    editMeasure(measure) {
        if (!measure || !this.state.startDate || !this.state.endDate) {
            toast('Niste unijeli sva obavezna polja!');
            this.setState({ measureErr: true, startDateErr: true, endDateErr: true });
        } else {
            let obj = {
                id: this.state.dmId,
                optLock: this.state.optLock,
                studentStudyProgram: { id: this.props.studentStudyProgramId },
                disciplinaryMeasure: { id: this.state.measure },
                startDate: moment(this.state.startDate).format(),
                endDate: moment(this.state.endDate).format(),
                documentNumber: this.state.documentNumber,
                comment: this.state.comment,
            };
            axios.put('disciplinary-procedure/edit/', { ...obj })
                .then(res => {
                    this.props.updateStatus();
                })
                .then(res => {
                    toast('Izmjena disciplinske mjere je uspješno izvršena.');
                    this.props.closeForm();
                    this.setState({ measureErr: false, startDateErr: false, endDateErr: false });
                })
                .catch(err => {
                    console.log('Failed to fetch filter results');
                });
        }
    }

    handleChange(name, date) {
        this.setState({
            [name]: date
        });
        if (name === 'endDate' && date < this.state.startDate && this.state.startDate) {
            this.setState({ [name]: null });
            toast('Datum kraja mora biti poslije datuma početka!');
        }
        if (name === 'startDate' && date > this.state.endDate && this.state.endDate) {
            this.setState({ [name]: null });
            toast('Datum početka mora biti prije datuma kraja!');
        }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    render() {
        return (<div>
            {/* eslint-disable-next-line react/jsx-no-undef */}
            <Segment secondary clearing>

                <Form noValidate>
                    <Grid columns="equal" centered className="stackable">
                        <Grid.Row >
                            <Grid.Column>
                                <Form.Group widths="equal" >
                                    <Form.Field required error={this.state.startDateErr}>
                                        <label>Datum početka disciplinske mjere</label>
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            defaultValue={new Date()}
                                            time={false}
                                            onChange={this.handleChange.bind(null, 'startDate')}
                                            value={this.state.startDate}
                                            placeholder="Unesite datum u formatu D. M. GGGG."
                                        />

                                    </Form.Field >
                                    <Form.Field required error={this.state.endDateErr}>
                                        <label>Datum kraja disciplinske mjere</label>
                                        <DateTimePicker
                                            format="D. M. YYYY."
                                            defaultValue={new Date()}
                                            time={false}
                                            onChange={this.handleChange.bind(null, 'endDate')}
                                            value={this.state.endDate}
                                            placeholder="Unesite datum u formatu D. M. GGGG."
                                        />

                                    </Form.Field >


                                </Form.Group>

                                <Form.Group widths="equal">

                                    <Form.Field required error={this.state.measureErr}>
                                        <label>Disciplinska mjera </label>
                                        <Form.Dropdown
                                            clearable
                                            selection
                                            placeholder="Odaberite mjeru"
                                            value={this.state.measure}
                                            onChange={this.handleInputChange}
                                            name="measure"
                                            options={this.state.measures}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                    <Form.Field required
                                        label="Broj odluke"
                                        control={Input}
                                        name="documentNumber"
                                        value={this.state.documentNumber}
                                        onChange={this.handleInputChange}
                                        placeholder="Unesite broj odluke"
                                    />


                                </Form.Group>
                            </Grid.Column>
                            <Grid.Column>

                                <Form.Field
                                    label="Obrazloženje"
                                    control={TextArea}
                                    rows={5}
                                    name="comment"
                                    value={this.state.comment}
                                    onChange={this.handleInputChange}
                                    placeholder="Unesite obrazloženje..."
                                />
                                <Button
                                    basic="true"
                                    color="blue"
                                    floated="right"
                                    onClick={this.props.closeForm}
                                >
                                    Odustani
                                </Button>
                                <Button
                                    color="blue"
                                    floated="right"
                                    onClick={this.props.edit ? () => this.editMeasure(this.state.measure) : () => this.addMeasures(this.state.measure)}
                                >
                                    {this.props.edit ? 'Izmijeni' : 'Dodaj'}
                                </Button>

                            </Grid.Column>
                        </Grid.Row>


                    </Grid>

                </Form>
            </Segment>
            <ToastContainer hideProgressBar />
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/AddDisciplinaryMeasures.js